module.exports = __webpack_public_path__ + "img/mario.04a79f4.png";